import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Helper } from '../../../helpers/helper';

// Servicios
import { PrestamosService } from '../../../services/prestamos.service';
import { RutasService } from '../../../services/rutas.service';
import { EmpleadosServicio } from '../../../services/empleado.service';
import { LowerCasePipe, CurrencyPipe } from '@angular/common';
import { AlertasModales } from '../../../helpers/alertasModales';

const ID_PAGINA = 17;

@Component({
  selector: 'app-cobros-del-dia',
  templateUrl: './cobros-del-dia.component.html',
  styleUrls: ['./cobros-del-dia.component.css']
})
export class CobrosDelDiaComponent implements OnInit {

  dropdownSettings: any;
  today;
  listaCobros = [];
  loaded = false;
  loading = false;
  page = 1;
  pagos = 0;
  notas = 0;
  limit = 50;
  offset = 0;
  size = 0;
  rutas = [];
  rutasSeleccionadas = [];
  rutasSeleccionadasAntes = false;
  fecha: NgbDateStruct;
  ce = '';
  totales: any;
  listaCobrosCabecera: Observable<any>;
  exportando = false;
  incluir = [
    { label: 'Activos', value: 1, checked: 0 },
    { label: 'Vencidos', value: 4, checked: 0 },
    { label: 'Incobrables', value: 5, checked: 0 }
  ];
  configPdf;
  active: number;
  columnsSort = [];
  private columnsServer = [];
  constructor(
    private prestamoService: PrestamosService,
    public empleadoService: EmpleadosServicio,
    private rutaService: RutasService,
    private route: ActivatedRoute,
    private router: Router,
    private modals: AlertasModales,
    private helper: Helper) {
    if (empleadoService.datosEmpleado.tipo_empleado !== 3
      // tslint:disable-next-line:triple-equals
      && !empleadoService.paginasAsignadas.filter(page => page.ID_PAGINA == ID_PAGINA).length) {
      this.router.navigate(['/404']);
    }
    this.rutasSeleccionadas = rutaService.getSelectedRoutes();
    if (this.rutasSeleccionadas.length > 0) {
      this.rutasSeleccionadasAntes = true;
    }
    this.fecha = {
      year: null,
      month: null,
      day: null
    };
    this.initRutas();
    this.initConfigPdf();
    this.initColumns();
  }

  ngOnInit() {
    this.verificarQueryString();
    this.initConfigMultiSelect();
    this.getCurDate();
  }

  private initConfigMultiSelect() {
    let badgeShowLimit = 1;
    if (window.matchMedia('(min-width: 992px)').matches) {
      badgeShowLimit = 5;
    } else if (window.matchMedia('(max-width: 992px)').matches) {
      badgeShowLimit = 3;
    } else {
      badgeShowLimit = 8;
    }

    this.dropdownSettings = {
      singleSelection: false,
      text: 'Seleccionar zona',
      selectAllText: 'Seleccionar todo',
      unSelectAllText: 'Deseleccionar todo',
      enableSearchFilter: true,
      classes: 'custom-multiselect',
      badgeShowLimit,
      searchPlaceholderText: 'Búsqueda'
    };
  }

  // Muestra los cobros del dia actual
  private initCobros(): void {
    this.loading = true;
    let fecha = '';

    if (this.fecha !== undefined && this.fecha !== null && this.fecha.year !== null) {
      fecha = `${this.fecha['year']}-${this.fecha['month']}-${this.fecha['day']}`;
    }

    const incluir = this.incluir.filter(i => i.checked).map(i => i.value).join();
    this.prestamoService.obtenerListaCobrosDia(
      this.limit,
      this.offset,
      this.rutasSeleccionadas.map(data => data.id).join(),
      this.ce,
      fecha,
      this.pagos,
      this.notas,
      incluir,
      JSON.stringify(this.columnsServer))
      .subscribe((res: any) => {
        this.active = parseFloat(localStorage.getItem('cobros_dia_active')) || -1;
        this.listaCobros = res.data;
        this.totales = res.totales;
        this.size = res.total_items;
        console.log(res.data);
        setTimeout(() => {
          this.loaded = true;
          this.loading = false;
        }, 1);
      });
  }

  getCurDate() {
    this.today = new Date();
    const dd = String(this.today.getDate()).padStart(2, '0');
    const mm = String(this.today.getMonth() + 1).padStart(2, '0');
    const yyyy = this.today.getFullYear();

    this.today = yyyy + '-' + mm + '-' + dd;
    console.log(this.today);

  }

  // Carga las rutas del empleado
  // private initRutas(): void {
  //   this.rutaService.cargarTodasLasRutas().subscribe(res => {
  //     this.rutas = res.rutas;
  //   });
  // }


  private initRutas(): void {
    this.rutaService.cargarTodasLasRutas().subscribe(res => {
      for (const ruta of res.rutas) {
        this.rutas.push({
          id: ruta.ID_RUTA,
          itemName: String(ruta.nombre)
        });
      }
    });
  }

  loadPage(page: number) {
    this.page = page;
    this.offset = this.limit * (this.page - 1);
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    queryParams['page'] = page;
    this.router.navigate(['./lista/reporte-cobros-dia'], { queryParams: queryParams });
  }

  // Carga los registros por querystring cuando se carga la página
  private verificarQueryString(): void {
    this.route.queryParams.subscribe(params => {
      if (params) {

        /*if (params.ruta) {
          this.rutasSeleccionadas = params.ruta;
        }*/
        if (params.rutas) {
          this.rutasSeleccionadas = [];
          for (const ruta of this.rutas) {
            for (const rutaSeleccionada of params.rutas.split(',')) {
              if (parseFloat(rutaSeleccionada) === ruta.id) {
                this.rutasSeleccionadas.push(ruta);
              }
            }
          }
          if (this.rutas.length > 0) {
            this.rutaService.setSelectedRoutes(this.rutasSeleccionadas);
          }
        }
        if  (this.rutasSeleccionadas.length > 0)  {

          this.rutaService.setSelectedRoutes(this.rutasSeleccionadas);
          this.rutasSeleccionadasAntes = false;
        } else {
          if  (this.rutasSeleccionadasAntes) {
            this.rutasSeleccionadas = this.rutaService.getSelectedRoutes();
            this.rutasSeleccionadasAntes = false;
          } else  {
            this.rutaService.removeSelectedRoutes();
          }

        }

        if (params.limite) {
          this.limit = params.limite;
        }

        if (params.fecha) {

          const year = parseFloat(params.fecha.split('-')[0]);
          const month = parseFloat(params.fecha.split('-')[1]);
          const day = parseFloat(params.fecha.split('-')[2]);
          if (!isNaN(year) && !isNaN(month) && !isNaN(day)) {
            this.fecha.year = year;
            this.fecha.month = month;
            this.fecha.day = day;
          } else {
            this.fecha = {
              year: null,
              month: null,
              day: null
            };
          }
        }
        if (params.nc) {
          this.ce = params.nc;
        }
        if (params.incluir) {
          for (const incluir of this.incluir) {
            for (const paramsIncluir of params.incluir.split(',')) {
              if (parseFloat(paramsIncluir) === incluir.value) {
                incluir.checked = 1;
              }
            }
          }
        } else {
          this.incluir[0].checked = 1;
        }

        if (params.pagos) {
          switch (params.pagos) {
            case 'pagos':
            case 'pago':
              this.pagos = 1; break;

            case 'no pagos':
            case 'no pago':
              this.pagos = 2; break;

            case 'incompleto':

              this.pagos = 3; break;

            default: this.pagos = 0; break;
          }
        }

        if (params.notas) {
          switch (params.notas) {
            case 'con notas':
            case 'con nota':
              this.notas = 1; break;

            case 'sin notas':
            case 'sin nota':
              this.notas = 2; break;

            default: this.notas = 0; break;
          }
        }

        if (params.page && !isNaN(params.page)) {
          this.page = parseFloat(params.page);
          this.offset = this.limit * (this.page - 1);
        }
        this.columnsServer = [];
        // tslint:disable-next-line:forin
        for (const columnParams in params) {
          for (const column of this.columnsSort) {
            if (column.label.replace(/\s/g, '').toLowerCase() === columnParams.replace('order', '')) {
              if (params[columnParams].toLowerCase() === 'asc' || params[columnParams].toLowerCase() === 'desc') {
                column.order = params[columnParams].toLowerCase();
                this.columnsServer.push(column);
                break;
              }
            }
          }
        }
        this.initCobros();
      }
    });
  }

  filtrarCobros() {
    this.page = 1;
    this.offset = 0;
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    queryParams['incluir'] = '';
    // queryParams['ruta'] = this.rutasSeleccionadas;
    const rutas = this.rutasSeleccionadas.map(data => data.id).join();
    if (rutas) {
      queryParams['rutas'] = rutas;
    } else {
      queryParams['rutas'] = '';
    }

    queryParams['limite'] = this.limit;
    if (this.fecha !== undefined && this.fecha !== null && this.fecha.year !== null) {
      queryParams['fecha'] = `${this.fecha['year']}-${this.fecha['month']}-${this.fecha['day']}`;
    }
    queryParams['nc'] = this.ce;

    switch (String(this.pagos)) {
      case '1': queryParams['pagos'] = 'pago'; break;
      case '2': queryParams['pagos'] = 'no pago'; break;
      case '3': queryParams['pagos'] = 'incompleto'; break;
      default: queryParams['pagos'] = 'todos'; break;
    }

    switch (String(this.notas)) {
      case '1': queryParams['notas'] = 'con notas'; break;
      case '2': queryParams['notas'] = 'sin notas'; break;
      default: queryParams['notas'] = 'todos'; break;
    }

    queryParams['incluir'] = this.incluir.filter(i => i.checked).map(i => i.value).join();
    this.router.navigate(['./lista/reporte-cobros-dia'], { queryParams: queryParams });
  }

  exportar(downOpen = true) {
    // tslint:disable-next-line:triple-equals
    if (this.empleadoService.permisosAsignados.filter(a => a.ID_PERMISO == 1).length
      || this.empleadoService.datosEmpleado.tipo_empleado === 3) {

      if (!this.exportando && this.listaCobros.length > 0) {
        this.exportando = true;

        let title = `Reporte de cobro`;
        const lowerCasePipe = new LowerCasePipe();
        const currencyPipe = new CurrencyPipe('en-US');
        if (this.rutasSeleccionadas) {
          title += ` de la ruta ${lowerCasePipe.transform(this.listaCobros[0].nombre_ruta)}`;
        } else {
          title += ' de todas las rutas';
        }

        const rows = [];
        const columns = [
          { title: 'Cliente', dataKey: '0' },
          {title: 'Dirección', dataKey: '1'},
          { title: 'Telefono', dataKey: '2' },
          { title: 'Cuota', dataKey: '3' },
          { title: 'C. NP', dataKey: '4' },
          // {title: 'CUOTA ACTUAL', dataKey: '5'},

          { title: 'P.ACTUAL', dataKey: '6' },

          { title: 'Pagado', dataKey: '7' },
           {title: 'Restante', dataKey: '8'},
          { title: 'Estado', dataKey: '9' },
        ];
        let fecha = '';

        if (this.fecha !== undefined && this.fecha !== null && this.fecha.year !== null) {
          fecha = `${this.fecha['year']}-${this.fecha['month']}-${this.fecha['day']}`;
        }
        const incluir = this.incluir.filter(i => i.checked).map(i => i.value).join();
        this.prestamoService.obtenerListaCobrosDia(
          0,
          0,
          this.rutasSeleccionadas.map(data => data.id).join(),
          this.ce,
          fecha,
          this.pagos,
          this.notas,
          incluir,
          JSON.stringify(this.columnsServer))
          .subscribe((res: any) => {
            this.active = parseFloat(localStorage.getItem('cobros_dia_active')) || -1;
            for (const row of res.data) {
              let estado = row.pago > 0 ? 'CON PAGO\r\n' : 'SIN PAGO\r\n';
              if (row.nota && row.pago === 0) {
                estado += 'CON NOTA\r\n';
              } else {
                estado += 'SIN NOTA\r\n';
              }

              rows.push({
                '0': this.helper.capitalizeFirstLetter(lowerCasePipe.transform(row.nombre + ' ' + row.apellido)),
                '1': this.helper.capitalizeFirstLetter(lowerCasePipe.transform(row.direccion)),
                '2': row.telefono,
                '3': currencyPipe.transform(row.monto_cuotas, '$', 'symbol', '1.0-0'),
                '4': currencyPipe.transform(row.cuota_por_cobrar, '$', 'symbol', '1.0-0'),
                // '5': row.cuota_por_cobrar ? 'PAGA' : 'NO PAGA',

                '6': currencyPipe.transform(row.monto_cuotas - row.cuota_por_cobrar, '$', 'symbol', '1.0-0'),

                '7': currencyPipe.transform(row.cuota_por_cobrar === 0 ? row.pago : row.pago || 0, '$', 'symbol', '1.0-0'),

                // tslint:disable-next-line:max-line-length
                '8': currencyPipe.transform( (row.monto_cuotas - row.pago) >= 0 ? row.monto_cuotas - row.pago : 0, '$', 'symbol', '1.0-0'),

                '9': estado,
              });
            }

            // Add footer
            rows.push({
              '0': `Total: ${rows.length}`,
              '3': currencyPipe.transform(res.data.reduce((a, b) => a + b.monto_cuotas, 0), '$', 'symbol', '1.0-0'),

              '4': currencyPipe.transform(res.data.reduce((a, b) => a + b.cuota_por_cobrar, 0), '$', 'symbol', '1.0-0'),

              '6': currencyPipe.transform(res.data.reduce((a, b) => a + b.monto_cuotas - b.cuota_por_cobrar, 0), '$', 'symbol', '1.0-0'),

              '7': currencyPipe.transform(
                res.data.reduce((a, b) => a + (b.cuota_por_cobrar === 0 ? b.monto_cuota || 0 : b.pago || 0)
                  , 0), '$', 'symbol', '1.0-0'),

              '8': currencyPipe.transform(
                res.data.reduce((a, b) => a + (b.cuota_por_cobrar === 0 ? b.monto_cuotas || b.pago : (b.monto_cuotas - b.pago) )
                  , 0), '$', 'symbol', '1.0-0')
            });

            const columnStyles = {
              id: { fillColor: 255, textColor: 0 },
              1: { columnWidth: 170 },
              2: { columnWidth: 40 },
            };
            // tslint:disable-next-line:comment-format
            //6: { columnWidth: 60 }

            // tslint:disable-next-line:max-line-length
            this.helper.exportarReportePdf(this.configPdf, title, columns, rows, this.empleadoService.datosEmpleado.nombreCompleto, columnStyles, 'p', downOpen)
              .then(() => {
                this.exportando = false;
              })
              .catch(() => {
                this.exportando = false;
              });
          });

      }
    } else {
      this.modals.validacionesModalJquery('No tienes permisos para realizar esta operación', '',
        'red',
        'modern',
        false,
        'fa fa-thumbs-down');
    }
  }

  private initConfigPdf(): void {
    this.prestamoService.obtenerConfiguracionPrestamo()
      .subscribe((res: any) => {
        this.configPdf = {
          direccion: res.direccion_recibo,
          tel: res.telefono_recibo,
          nombre_compania: res.descripcion,
          rnc_compania: res.rnc,
          fax_compania: res.fax,
          email_compania: res.email,
          ciudad_compania: res.ciudad,
          tel_compania: res.telefono,
          direccion_compania: res.direccion
        };
      });
  }

  navigate(cobro) {
    localStorage.setItem('cobros_dia_active', cobro.ID_C);
    this.router.navigate(['/cliente', cobro.ID_C]);
  }

  modalNotas(cobro) {
    localStorage.setItem('cobros_dia_active', cobro.ID_C);
    this.active = cobro.ID_C;
    this.modals.notasClienteNgbModal(cobro);
  }

  addNota(cobro) {
    localStorage.setItem('cobros_dia_active', cobro.ID_C);
    this.active = cobro.ID_C;
    this.modals.comentarioClienteNgbModal(cobro.ID_C);
  }

  modalPagos(cobro) {
    localStorage.setItem('cobros_dia_active', cobro.ID_C);
    this.active = cobro.ID_C;
    this.modals.historialPagosNgbModal(cobro.ID_PRESTAMO);
  }

  orderTable(column) {
    if (!column.order) {
      column.order = 'desc';
    } else {
      column.order = column.order === 'desc' ? 'asc' : 'desc';
    }
    const queryParams: Params = Object.assign({}, this.route.snapshot.queryParams);
    delete queryParams[`order${column.label.replace(/\s/g, '').toLowerCase()}`];
    queryParams[`order${column.label.replace(/\s/g, '').toLowerCase()}`] = column.order;
    this.router.navigate(['./lista/reporte-cobros-dia'], { queryParams: queryParams });
  }

  private initColumns(): void {
    this.columnsSort = [
      {
        label: 'Cliente',
        column: `CONCAT(c.nombre, ' ', c.apellido)`,
        order: ''
      },
      {
        label: 'Dirección',
        column: 'c.direccion',
        order: ''
      },
      {
        label: 'Teléfono',
        column: 'c.telefono',
        order: ''
      },
      {
        label: 'Zona',
        column: 'nombre_ruta',
        order: ''
      },
      {
        label: 'Cuota',
        column: 'monto_cuotas',
        order: ''
      },
      {
        label: 'Cuota NP',
        column: 'cuota_por_cobrar',
        order: ''
      },
      {
        label: 'P.ACTUAL',
        column: 'cuota_por_cobrar',
        order: ''
      },

      {
        label: 'Pagado',
        column: 'pago',
        order: ''
      },

      {
        label: 'CUOTA ACTUAL',
        column: 'cuota_por_cobrar',
        order: ''
      },
      //  {
      //    label: 'restante',
      //    column: '(monto_cuotas - pago)',
      //    order: ''
      //  },
    ];
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/cobros/cobros-del-dia/cobros-del-dia.component.ts